<template>
  <div>
    <div class="card">
      <h5 class="card-header">SPSS Excel</h5>
      <div class="card-body">
        <form ref="form" class="needs-validation" :class="formWasValidated ? 'was-validated' : ''" novalidate @submit.prevent>
          <div class="form-group">
            <label for="referenceNumber" class="">Page Number (Page Size = 100 Reports)</label>
            <input
              type="number"
              v-model="pageNumber"
              class="form-control"
              id="pageNumber"
              placeholder="Page Number to download"
              required
              min="1"
              :disabled="loadingMessage"
              @keyup.enter="submit"
            />
            <div class="invalid-feedback">
              Please provide a page number greater than 0.
            </div>
            <button type="submit" class="btn btn-primary mt-3" @click="excelExport" :disabled="isExporting">
              <fa v-if="isExporting" icon="circle-notch" spin />
              <fa v-if="!isExporting" icon="file-excel" />
              <span class="ml-2">Excel Export</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formWasValidated: false,
      pageNumber: null,
      isExporting: false,
    };
  },
  methods: {
    reset() {
      this.isExporting = false;
      this.pageNumber = null;
      this.formWasValidated = false;
    },
    excelExport() {
      this.isExporting = true;

      const payload = {
        pageNumber: parseInt(this.pageNumber),
      };

      // validations
      if (!this.$refs.form.checkValidity()) {
        this.formWasValidated = true;
        this.isExporting = false;
        return;
      }

      this.$axios
        .post("/v1/admin/spss/excel", payload)
        .then(res => {
          const link = document.createElement("a");
          link.target = "_blank";
          link.rel = "noopener noreferrer";
          link.href = res.data.url;
          link.click();
          link.remove();
        })
        .finally(() => {
          this.isExporting = false;
          this.reset();
        });
    },
  },
};
</script>
